import { Path, Svg } from "react-native-svg";
type Props = {
  filled?: boolean;
};
export const Star = ({
  filled
}: Props) => {
  const fill = filled ? "#FBA11A" : "#9397B7";
  const fillOpacity = filled ? 1 : 0.5;
  return <Svg width={31} height={28} viewBox="0 0 31 28" fill="none" data-sentry-element="Svg" data-sentry-component="Star" data-sentry-source-file="Star.tsx">
      <Path d="M15.5 0L18.98 10.3647H30.2414L21.1307 16.7705L24.6107 27.1353L15.5 20.7295L6.38933 27.1353L9.8693 16.7705L0.758624 10.3647H12.02L15.5 0Z" fill={fill} fillOpacity={fillOpacity} data-sentry-element="Path" data-sentry-source-file="Star.tsx" />
    </Svg>;
};